import { INotificationPeriod } from "models/NotificationPeriodModel";
import { BaseService } from "./base.service";

class NotificationPeriodServiceInternal extends BaseService {
	getNotificationPeriodList = async (): Promise<INotificationPeriod[]> =>
		this.callApi<INotificationPeriod[]>(
			`NotificationPeriod/GetNotificationPeriodList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const NotificationPeriodService =
	new NotificationPeriodServiceInternal();
